import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { useAppSelector } from "../../../store/reducers";
import { getAddressParts } from "../../../utils/format";
import { Step } from "../constants";

type IProps = Immutable<{
    onEdit?: (event?: React.MouseEvent<HTMLElement>) => void;
}>;

export const ShippingAddressSummary = (props: IProps): React.ReactNode => {
    const user = useAppSelector((state) => state.common.user);
    const form = useAppSelector((state) => state.checkout.form);
    const showSummary = useAppSelector(
        (state) => state.checkout.form.current_step > Step.SHIPPING_ADDRESS,
    );

    const summaryClasses = classNames({
        "checkout-step__summary": true,
        "checkout-step__summary--collapsed": !showSummary,
    });

    return (
        <div className={summaryClasses}>
            <h3 className="checkout-step__label">{t`Ship to:`}</h3>
            <div className="checkout-step__summary-address">
                {`${form.shipping_first_name} ${form.shipping_last_name}`}
                <br />
                {form.shipping_line1}
                <br />
                {form.shipping_line2 && (
                    <>
                        {form.shipping_line2}
                        <br />
                    </>
                )}
                {
                    getAddressParts({
                        line1: form.shipping_line1,
                        line2: form.shipping_line2,
                        city: form.shipping_line4,
                        state: form.shipping_state,
                        postal: form.shipping_postcode,
                    }).cityStatePostal
                }
                <br />
                {form.shipping_phone_number}
                <br />
                {user && user.email && !user.is_csr
                    ? user.email
                    : form.guest_email}
                <br />
            </div>
            {props.onEdit && (
                <a
                    className="checkout-step__back"
                    href="#"
                    onClick={props.onEdit}
                >
                    {t`Edit`}
                </a>
            )}
        </div>
    );
};
